import Vue from 'vue'

export const state = () => ({
  startDate: null,
  endDate: null,
  timespan: 'month',
  dashboardDataSpan: 'day',
  dashboardData: null,
  timeseries: {
    users: null,
    signatures: null,
    contracts: null,
    hms_contracts: null,
    listing_publish: null
  }
})

export const mutations = {
  setTimeseries(state, data) {
    data.value.timeseries.sort(
      (a, b) => new Date(a.timespan) - new Date(b.timespan)
    )
    Vue.set(state.timeseries, data.timeseries.replace('-', '_'), data.value)
  },
  setStartDate(state, value) {
    state.startDate = value
  },
  setEndDate(state, value) {
    state.endDate = value
  },
  setTimespan(state, value) {
    state.timespan = value
  },
  setDashboardData(state, value) {
    state.dashboardData = value
  },
  setDashboardDataSpan(state, value) {
    state.dashboardDataSpan = value
  }
}

export const actions = {
  fetchTimeseries({ state, commit }, timeseriesName) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`staff/timeseries/${timeseriesName}/`, {
          params: {
            start_date: state.startDate,
            end_date: state.endDate,
            timespan: state.timespan
          }
        })
        .then((response) => {
          commit('setTimeseries', {
            value: response.data,
            timeseries: timeseriesName
          })
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchDashboardData({ state, commit }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`staff/dashboard/data/`, {
          params: {
            span: state.dashboardDataSpan
          }
        })
        .then((response) => {
          commit('setDashboardData', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  sendMessage(context, { id, msg }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`conversations/${id}/messages/`, {
          message: msg
        })
        .then((response) => {
          context.commit('addNewMessage', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
